/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface ZoneUpdateFields
 */
export interface ZoneUpdateFields {
    /**
     * Names String. For example zone name, group name or custom_id
     * @type {string}
     * @memberof ZoneUpdateFields
     */
    name: string;
    /**
     * @type {boolean}
     * @memberof ZoneUpdateFields
     */
    live_status: boolean;
    /**
     * @type {number}
     * @memberof ZoneUpdateFields
     */
    project_id?: number;
}
